import { Component } from '@angular/core';

@Component({
  template: ``,
  styles: []
})
export class NotFoundComponent {
  constructor() { }
}



// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/not-found/not-found.component.ts